import { PropertyType } from '../../../common';

export const mapToFormData = (data: PropertyType): PropertyType => {
	const formData = new FormData();
	const keys = Object.keys(data);

	keys.forEach((key) => {
		if (key !== 'filters') {
			formData.append(key, data[key]);
		} else {
			formData.append(key, JSON.stringify(data[key]));
		}
	});
	return formData;
};

export const mapEntityToApi = (data: PropertyType): PropertyType => {
	const { campaignForm, token } = data;
	const apiData: PropertyType = {
		sid: token,
	};

	apiData.all_games = campaignForm.all_games ? 1 : 0;
	apiData.all_users = campaignForm.all_users ? 1 : 0;
	apiData.allow_api_award = campaignForm.allow_api_award ? 1 : 0;
	apiData.auto_award_on_launch = campaignForm.auto_award_on_launch ? 1 : 0;

	if (campaignForm.campaign_name) apiData.campaign_name = campaignForm.campaign_name;
	if (campaignForm.campaign_rules) apiData.rules = campaignForm.campaign_rules;
	if (campaignForm.campaign_description) apiData.campaign_description = campaignForm.campaign_description;
	if (campaignForm.status?.length) {
		apiData.status = campaignForm.status[0].value === 'enabled' ? 1 : 0;
	}
	if (campaignForm.from_date) apiData.from_date = campaignForm.from_date;
	if (campaignForm.to_date) apiData.to_date = campaignForm.to_date;

	if (campaignForm.games?.length) {
		apiData.games = campaignForm.games.map((g: PropertyType) => g.value);
	}

	if (campaignForm.partners?.length) {
		apiData.partners = campaignForm.partners;
	}

	if (campaignForm.device?.length) {
		apiData.device = campaignForm.device[0].value;
	}

	if (campaignForm.provider_id.length) apiData.provider_id = campaignForm.provider_id[0].value;
	if (campaignForm.free_spin_bet_value) apiData.free_spin_bet_value = campaignForm.free_spin_bet_value;
	if (campaignForm.free_spin_total_value) apiData.free_spin_total_value = campaignForm.free_spin_total_value;
	if (campaignForm.money_drop_currency) apiData.money_drop_currency = campaignForm.money_drop_currency;
	if (campaignForm.from_spin_expiry) apiData.from_spin_expiry = campaignForm.from_spin_expiry;
	if (campaignForm.number_of_prizes?.length) {
		const numberOfPrizes = campaignForm.number_of_prizes.map((value: string | number) => parseInt(`${value}`, 10) || 0);
		apiData.number_of_prizes = numberOfPrizes;

		const prizeValues =
			campaignForm.prize_value?.map((value: string | number) => {
				const numeric = parseFloat(`${value}`);
				if (Number.isNaN(numeric)) return 0;

				return Math.round(numeric * 100);
			}) ?? [];
		apiData.prize_value = prizeValues;

		const prizes = numberOfPrizes.reduce((list: number[], count: number, index: number) => {
			const prizeVal = prizeValues[index] ?? 0;
			if (!count || !prizeVal) {
				return list;
			}

			return list.concat(Array(count).fill(prizeVal));
		}, [] as number[]);

		apiData.prizes = prizes;
		apiData.prize_pool = prizes.reduce((total: number, prize: number) => total + prize, 0);
	}

	return apiData;
};
